import * as React from 'react';

import cn from 'classnames';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import CommonItem from '../CommonItem/CommonItem';
import { useStartCheckIn, StartCheckInButton } from '@features/start-check-in';

const OrderCardControls: React.FC = props => {
	const { isCheckinAvailable } = useStartCheckIn();

	const { t } = useTranslation('OrderCard');
	const theme = useTheme('OrderCard').OrderCardControls;

	if (!isCheckinAvailable) {
		return null;
	}

	return (
		<CommonItem
			className={theme.root}
			icon={'Document/Boarding pass'}
			text={t('Online check-in started')}
			buttons={<StartCheckInButton buttonClassName={cn(theme.button, theme.button_checkin)} />}
		/>
	);
};

export default OrderCardControls;
